import { c as _c } from "react/compiler-runtime";
import { FormInput, RadioGroup, RadioGroupDataInterface } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { LectureInterface } from 'modules/courses/courses/curriculum/types/lecture-interface';
import { createLectureEmail } from 'modules/courses/emails/api/lecture-email-api';
import { LectureEmailCreateInterface } from 'modules/courses/emails/types/lecture-email-inteface';
import EmailTemplateSelector from 'modules/email/components/email-template-selector/email-template-selector';
import { useGetEmailTemplates } from 'modules/email/hooks/use-get-email-templates';
import { CreateEmailInterface } from 'modules/mailing/types/mailing-interface';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import CreateModal, { CreateModalProps } from 'shared/components/create-modal';
import { useEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-email-options';
import SenderEmailSelect from 'shared/components/sender-email-select';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateLectureEmail } from '../../../../emails/hooks/use-update-lecture-email';
import { CourseId } from '../../../types/course-interface';
import { useUpdateLectureData } from '../../hooks/use-update-lecture-data';
import { CourseLectureEmailErrorResponseContentInterface } from '../../types/course-lecture-email-error-response-interface';
import { getCourseLectureEmailUrl } from '../../utils/get-course-lecture-email-url';
const defaultErrors: CreateModuleErrorsInterface = {
  fromEmail: '',
  fromName: '',
  subject: '',
  useNewEditor: '',
  template: ''
};
const defaultValues: CreateEmailInterface = {
  fromEmail: '',
  fromName: '',
  subject: '',
  useNewEditor: true,
  template: undefined
};
export type CreateModuleErrorsInterface = Record<keyof CreateEmailInterface, string>;
interface LectureEmailActionProps extends Pick<CreateModalProps<CreateEmailInterface>, 'onClose'> {
  lecture: LectureInterface;
  isOpened: boolean;
}
export function LectureEmailAction(t0) {
  const $ = _c(58);
  const {
    lecture,
    isOpened,
    onClose
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const courseId = Number(router.query.courseId) as CourseId;
  const [errors, setErrors] = useState(defaultErrors);
  const [values, setValues] = useState(defaultValues);
  const {
    data: options
  } = useEmailOptions();
  const {
    templates
  } = useGetEmailTemplates();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.email_template_selector.template_visual_editor");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      id: "new",
      caption: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.email_template_selector.template_classic_editor");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      id: "old",
      caption: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = [t2, t4];
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const templateTypeData = t5;
  const updateLectureData = useUpdateLectureData(courseId);
  const updateLectureEmail = useUpdateLectureEmail(lecture.id);
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setErrors(defaultErrors);
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const afterLeave = t6;
  let t7;
  if ($[12] !== courseId || $[13] !== lecture.id || $[14] !== router || $[15] !== updateLectureData || $[16] !== updateLectureEmail) {
    t7 = async data => {
      ;
      try {
        const createData = {
          drippingAccessMailing: {
            currentEmail: {
              subject: data.subject,
              fromName: data.fromName,
              fromEmail: data.fromEmail,
              useNewEditor: data.useNewEditor,
              template: data.template
            }
          }
        };
        await createLectureEmail(lecture.id, createData);
        await updateLectureData(false);
        await updateLectureEmail(false);
        router.push(getCourseLectureEmailUrl({
          courseId,
          lectureId: lecture.id
        }));
      } catch (t8) {
        const e = t8;
        if (e instanceof BadRequest) {
          const errors_0 = e.errors as CourseLectureEmailErrorResponseContentInterface;
          const fields = errors_0.fields;
          if (!Array.isArray(fields)) {
            const emailErrors = fields.drippingAccessMailing?.currentEmail;
            setErrors(prev => ({
              ...prev,
              fromEmail: emailErrors?.fromEmail?.join("") || "",
              fromName: emailErrors?.fromName?.join("") || "",
              subject: emailErrors?.subject?.join("") || "",
              template: emailErrors?.template?.join("") || ""
            }));
          }
          if (e.errors.common) {
            const commonErrors = e.errors.common;
            setErrors(prev_0 => ({
              ...prev_0,
              common: commonErrors
            }));
          }
        }
        throw e;
      }
    };
    $[12] = courseId;
    $[13] = lecture.id;
    $[14] = router;
    $[15] = updateLectureData;
    $[16] = updateLectureEmail;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const onCreate = t7;
  let t8;
  let t9;
  if ($[18] !== options) {
    t8 = () => {
      if (options) {
        setValues(prev_1 => ({
          ...prev_1,
          fromEmail: prev_1.fromEmail || options?.senderEmailAddress,
          fromName: prev_1.fromName || options?.senderName
        }));
      }
    };
    t9 = [options];
    $[18] = options;
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[21] !== templates) {
    t10 = () => {
      if (templates) {
        setValues(prev_2 => ({
          ...prev_2,
          template: templates?.[0].id
        }));
      }
    };
    t11 = [templates];
    $[21] = templates;
    $[22] = t10;
    $[23] = t11;
  } else {
    t10 = $[22];
    t11 = $[23];
  }
  useEffect(t10, t11);
  const t12 = !options;
  let t13;
  if ($[24] !== t) {
    t13 = t("global.email");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["subject", "fromName", "fromEmail"];
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== errors || $[28] !== t) {
    t15 = {
      field: "subject",
      onRender: (value, onChange) => <FormInput required={true} key="newsletter-subject" label={t("dashboard.email.subject")} value={value} onChange={e_0 => onChange(e_0.target.value)} maxLength={256} error={errors.subject} />
    };
    $[27] = errors;
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== errors || $[31] !== t) {
    t16 = {
      field: "fromName",
      onRender: (value_0, onChange_0) => <FormInput required={true} key="sender-name" label={t("dashboard.email.sender_name")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} maxLength={256} error={errors.fromName} />
    };
    $[30] = errors;
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== errors || $[34] !== options) {
    t17 = {
      field: "fromEmail",
      onRender: (value_1, onChange_1) => <SenderEmailSelect required={true} key="sender-email" isPreFetching={!options} onChange={data_0 => data_0 && onChange_1(data_0)} value={value_1} error={errors.fromEmail} />
    };
    $[33] = errors;
    $[34] = options;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== templateTypeData || $[37] !== templates?.[0]) {
    t18 = {
      field: "useNewEditor",
      onRender: (value_2, onChange_2, state, onChangeState) => <RadioGroup key="editor-type" options={templateTypeData} selected={value_2 ? "new" : "old"} onChange={value_3 => {
        if (value_3 === "old") {
          onChangeState({
            ...state,
            useNewEditor: false,
            template: undefined
          });
        } else {
          onChangeState({
            ...state,
            useNewEditor: true,
            template: templates?.[0].id
          });
        }
      }} />
    };
    $[36] = templateTypeData;
    $[37] = templates?.[0];
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== templates) {
    t19 = {
      field: "template",
      shouldRender: _temp,
      onRender: (value_4, onChange_3) => <EmailTemplateSelector key="template" onChange={onChange_3} templateId={value_4} templates={templates} />
    };
    $[39] = templates;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t15 || $[42] !== t16 || $[43] !== t17 || $[44] !== t18 || $[45] !== t19) {
    t20 = [t15, t16, t17, t18, t19];
    $[41] = t15;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== onCreate || $[48] !== values) {
    t21 = data_1 => onCreate({
      ...values,
      ...data_1
    });
    $[47] = onCreate;
    $[48] = values;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== isOpened || $[51] !== onClose || $[52] !== t12 || $[53] !== t13 || $[54] !== t20 || $[55] !== t21 || $[56] !== values) {
    t22 = <CreateModal opened={isOpened} isPrefetching={t12} onClose={onClose} afterLeave={afterLeave} defaultValues={values} caption={t13} requiredFields={t14} creatable={t20} onCreate={t21} />;
    $[50] = isOpened;
    $[51] = onClose;
    $[52] = t12;
    $[53] = t13;
    $[54] = t20;
    $[55] = t21;
    $[56] = values;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  return t22;
}
function _temp(state_0) {
  return state_0.useNewEditor;
}